import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

export const useWindowSize = () => {
	const isClient = !__SERVER__;

	const getSize = () => ({
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		width: isClient ? window.innerWidth : undefined,

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		height: isClient ? window.innerHeight : undefined,
	});

	const [windowSize, setWindowSize] = useState(getSize());

	const onResize = () => {
		setWindowSize(getSize());
	};

	const onResizeDebounced = debounce(onResize, 100, { leading: true, trailing: true });

	useEffect(() => {
		if (!isClient) {
			return undefined;
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.addEventListener('resize', onResizeDebounced);

		return () => {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.removeEventListener('resize', onResizeDebounced);
		};
	}, [onResizeDebounced, isClient]);

	return [windowSize.width, windowSize.height] as const;
};
